export default __webpack_public_path__ + "./images/ir.6072b993.png";